import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import ArrowDownSmall from '@icons/arrow/ArrowDownSmall';
import { useMemo } from 'react';

interface Props {
    options?: {value: string, label: string}[];
    placeholder?: string;
    value?: string;
    /** 탭했을 때 호출한다. 선택지는 별도 stackflow BottomSheet 액티비티로 띄운다 */
    onClick: () => void;
    /** TextField 와 같이 하단에 오류 메시지를 띄우고 테두리를 오류 색으로 바꾼다 */
    errorText?: string;
}

/** Figma Selectbox. 탭하면 onClick 으로 선택지 BottomSheet 를 연다. */
function Dropdown({
    options, placeholder, value, onClick, errorText,
}:Props) {
    const displayValue = useMemo<string|undefined>(() => {
        if (value) {
            return options?.find((option) => option.value === value)?.label;
        }
        return undefined;
    }, [options, value]);
    return (
        <Container>
            <Button onClick={onClick}
                type='button'
                aria-invalid={!!errorText}>
                <Text ellipsis
                    color={displayValue ? colors.textPrimary : colors.textUnselected}>
                    {displayValue || placeholder}
                </Text>
                <ArrowDownSmall size={16}
                    color={colors.textSecondary}/>
            </Button>
            {errorText && (
                <Text color={colors.textError} size='body-long'>{errorText}</Text>
            )}
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 4px;
    width: 100%;
`;

const Button = styled.button`
    align-items: center;
    background-color: var(--color-background-pure);
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-sm);
    column-gap: var(--spacing-4);
    display: flex;
    justify-content: space-between;
    padding: var(--spacing-4);
    text-align: left;
    width: 100%;

    > :first-child {
        flex: 1;
        min-width: 0;
    }

    > svg {
        flex-shrink: 0;
    }

    &[aria-invalid="true"] {
        border-color: var(--color-red2);
    }
`;

export default Dropdown;
